<template>
  <div class="driver-container">
    <div class="page-header">
      <h2>司机管理</h2>
      <p>管理公司司机信息</p>
    </div>
    
    <div class="content-area">
      <el-card>
        <template #header>
          <div class="card-header">
            <span>司机列表</span>
            <div class="header-actions">
              <el-button type="primary" size="small" @click="handleAdd">新建司机</el-button>
              <el-button type="success" size="small" @click="handleRefresh">刷新数据</el-button>
            </div>
          </div>
        </template>
        
        <!-- 搜索区域 -->
        <div class="search-area">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="司机名称">
              <el-input v-model="searchForm.name" placeholder="请输入司机名称" clearable />
            </el-form-item>
            <el-form-item label="司机电话">
              <el-input v-model="searchForm.phone" placeholder="请输入司机电话" clearable />
            </el-form-item>
            <el-form-item label="车牌号码">
              <el-input v-model="searchForm.card" placeholder="请输入车牌号码" clearable />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 司机列表 -->
        <el-table
          :data="driverList"
          v-loading="loading"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" />
          <el-table-column prop="name" label="司机名称" width="120" />
          <el-table-column prop="phone" label="司机电话" width="130" />
          <el-table-column prop="card" label="车牌号码" width="120" />
          <el-table-column prop="address" label="司机地址" width="200" show-overflow-tooltip />
          <el-table-column prop="createtime" label="创建时间" width="180">
            <template #default="scope">
              {{ formatDate(scope.row.createtime) }}
            </template>
          </el-table-column>
          <el-table-column prop="updatetime" label="更新时间" width="180">
            <template #default="scope">
              {{ formatDate(scope.row.updatetime) }}
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="司机备注" show-overflow-tooltip />
          <el-table-column label="操作" width="200" fixed="right">
            <template #default="scope">
              <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-area">
          <el-pagination
            v-model:current-page="pagination.currentPage"
            v-model:page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </el-card>
    </div>

    <!-- 添加/编辑司机对话框 -->
    <el-dialog
      :title="dialogTitle"
      v-model="dialogVisible"
      width="700px"
      @close="handleDialogClose">
      
      <!-- 快速输入区域 -->
      <div class="quick-input-area" v-if="!driverForm.id">
        <div class="quick-input-header">
          <span class="quick-input-title">快速输入</span>
          <el-button type="primary" size="small" @click="parseDriverInfo" :loading="parsing">
            一键解析
          </el-button>
        </div>
        <el-input
          v-model="quickInputText"
          type="textarea"
          :rows="4"
          placeholder="请输入司机信息，格式如：张三 13812345678 京A12345 北京市朝阳区xxx"
          class="quick-input-textarea" />
        <div class="quick-input-tip">
          提示：请按"姓名 电话 车牌 地址"的格式输入，用空格或换行分隔
        </div>
      </div>

      <el-divider v-if="!driverForm.id" />

      <el-form
        ref="driverFormRef"
        :model="driverForm"
        :rules="driverRules"
        label-width="100px">
        <el-form-item label="司机名称" prop="name">
          <el-input v-model="driverForm.name" placeholder="请输入司机名称" />
        </el-form-item>
        <el-form-item label="司机电话" prop="phone">
          <el-input v-model="driverForm.phone" placeholder="请输入司机电话" />
        </el-form-item>
        <el-form-item label="车牌号码" prop="card">
          <el-input v-model="driverForm.card" placeholder="请输入车牌号码" />
        </el-form-item>
        <el-form-item label="司机地址">
          <el-input v-model="driverForm.address" placeholder="请输入司机地址" />
        </el-form-item>
        <el-form-item label="司机备注">
          <el-input
            v-model="driverForm.remarks"
            type="textarea"
            :rows="3"
            placeholder="请输入司机备注信息" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: 'DriverPage',
  data() {
    return {
      loading: false,
      driverList: [],
      selectedDrivers: [],
      searchForm: {
        name: '',
        phone: '',
        card: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新建司机',
      submitting: false,
      parsing: false,
      quickInputText: '',
      driverForm: {
        id: '',
        name: '',
        phone: '',
        card: '',
        address: '',
        remarks: ''
      },
      driverRules: {
        name: [
          { required: true, message: '请输入司机名称', trigger: 'blur' },
          { min: 2, max: 50, message: '司机名称长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入司机电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        card: [
          { required: true, message: '请输入车牌号码', trigger: 'blur' },
          { pattern: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-Z0-9]{4,5}[A-Z0-9挂学警港澳]$/, message: '请输入正确的车牌号码', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    driverFormRef() {
      return this.$refs.driverFormRef
    }
  },
  mounted() {
    this.getDriverList()
  },
  methods: {
    // 获取司机列表
    async getDriverList() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        }
        
        const response = await this.$axios.get('/api/driver/getlist', { params })
        if (response.code === 1) {
          this.driverList = response.data || []
          this.pagination.total = response.total || 0
        } else {
          ElMessage.error(response.msg || '获取司机列表失败')
        }
      } catch (error) {
        console.error('获取司机列表失败:', error)
        ElMessage.error('获取司机列表失败')
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.getDriverList()
    },

    // 重置搜索
    handleReset() {
      this.searchForm = {
        name: '',
        phone: '',
        card: ''
      }
      this.pagination.currentPage = 1
      this.getDriverList()
    },

    // 新建司机
    handleAdd() {
      this.dialogTitle = '新建司机'
      this.driverForm = {
        id: '',
        name: '',
        phone: '',
        card: '',
        address: '',
        remarks: ''
      }
      this.quickInputText = ''
      this.dialogVisible = true
    },

    // 编辑司机
    handleEdit(row) {
      this.dialogTitle = '编辑司机'
      this.driverForm = { ...row }
      this.dialogVisible = true
    },

    // 删除司机
    async handleDelete(row) {
      try {
        await ElMessageBox.confirm(
          `确定要删除司机 "${row.name}" 吗？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
        
        const response = await this.$axios.post('/driver/delete', { id: row.id })
        if (response.code === 1) {
          ElMessage.success('删除成功')
          this.getDriverList()
        } else {
          ElMessage.error(response.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除司机失败:', error)
          ElMessage.error('删除失败')
        }
      }
    },

    // 刷新数据
    handleRefresh() {
      this.getDriverList()
      ElMessage.success('数据已刷新')
    },

    // 解析司机信息
    parseDriverInfo() {
      if (!this.quickInputText.trim()) {
        ElMessage.warning('请输入要解析的司机信息')
        return
      }

      this.parsing = true
      
      try {
        // 清理输入文本，去除多余空格和换行
        const cleanText = this.quickInputText.replace(/\s+/g, ' ').trim()
        
        // 按空格分割文本
        const parts = cleanText.split(' ')
        
        if (parts.length < 3) {
          ElMessage.warning('请输入完整的司机信息，至少包含姓名、电话、车牌')
          return
        }

        // 解析各个字段
        let name = parts[0] || ''
        let phone = ''
        let card = ''
        let address = parts.slice(3).join(' ') || ''

        // 查找手机号码
        for (let i = 1; i < parts.length; i++) {
          if (/^1[3-9]\d{9}$/.test(parts[i])) {
            phone = parts[i]
            // 车牌号码在手机号码后面
            if (i + 1 < parts.length) {
              card = parts[i + 1]
              // 地址在车牌号码后面
              if (i + 2 < parts.length) {
                address = parts.slice(i + 2).join(' ')
              }
            }
            break
          }
        }

        // 如果没有找到手机号码，尝试其他方式解析
        if (!phone) {
          // 假设第二个部分是手机号码
          if (parts.length >= 2 && /^1[3-9]\d{9}$/.test(parts[1])) {
            phone = parts[1]
            card = parts[2] || ''
            address = parts.slice(3).join(' ') || ''
          } else {
            // 如果还是找不到，使用简单分配
            phone = parts[1] || ''
            card = parts[2] || ''
            address = parts.slice(3).join(' ') || ''
          }
        }

        // 更新表单数据
        this.driverForm.name = name
        this.driverForm.phone = phone
        this.driverForm.card = card
        this.driverForm.address = address

        ElMessage.success('信息解析成功')
      } catch (error) {
        console.error('解析司机信息失败:', error)
        ElMessage.error('解析失败，请检查输入格式')
      } finally {
        this.parsing = false
      }
    },

    // 提交表单
    async handleSubmit() {
      if (!this.driverFormRef) return

      try {
        await this.driverFormRef.validate()
        this.submitting = true

        let response
        if (this.driverForm.id) {
          // 编辑司机
          response = await this.$axios.post('/driver/edit', this.driverForm)
        } else {
          // 新建司机
          response = await this.$axios.post('/driver/add', this.driverForm)
        }

        if (response.code === 1) {
          ElMessage.success(this.driverForm.id ? '编辑成功' : '新建成功')
          this.dialogVisible = false
          this.getDriverList()
        } else {
          ElMessage.error(response.msg || '操作失败')
        }
      } catch (error) {
        if (error.response) {
          ElMessage.error(error.response.msg || '操作失败')
        }
      } finally {
        this.submitting = false
      }
    },

    // 对话框关闭
    handleDialogClose() {
      this.driverFormRef?.resetFields()
      this.quickInputText = ''
    },

    // 选择司机
    handleSelectionChange(selection) {
      this.selectedDrivers = selection
    },

    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.currentPage = 1
      this.getDriverList()
    },

    // 当前页改变
    handleCurrentChange(page) {
      this.pagination.currentPage = page
      this.getDriverList()
    },

    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.driver-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  color: #303133;
}

.page-header p {
  margin: 5px 0 0 0;
  color: #909399;
  font-size: 14px;
}

.content-area {
  margin-top: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.search-area {
  margin-bottom: 20px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.pagination-area {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.quick-input-area {
  margin-bottom: 20px;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.quick-input-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.quick-input-title {
  font-weight: 600;
  color: #303133;
}

.quick-input-textarea {
  margin-bottom: 8px;
}

.quick-input-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}
</style>
